import type { BrandConfig } from './types';

export const deltaDental: BrandConfig = {
  key: 'delta-dental',
  name: 'Delta Dental',
  appTitle: 'Delta Dental Security Hub',
  appSubtitle: 'Security Hub',

  colors: {
    // Delta Dental green — anchor brand color (#2db035 from deltadentalmn.org)
    primary: {
      50: '#f4fbf5',
      100: '#e6f6e7',
      200: '#c4e9c6',
      300: '#9edba2',
      400: '#6cc872',
      500: '#2db035',
      600: '#25902b',
      700: '#1d7122',
      800: '#144f18',
      900: '#0d310f',
      950: '#071a08',
    },
    // Neutral slate chrome
    secondary: {
      50: '#f8fafc',
      100: '#f1f5f9',
      200: '#e2e8f0',
      300: '#cbd5e1',
      400: '#94a3b8',
      500: '#64748b',
      600: '#475569',
      700: '#334155',
      800: '#1e293b',
      900: '#0f172a',
      950: '#020617',
    },
    // Cyan accent for CTAs and links (#00aec7 from deltadentalmn.org)
    accent: {
      50: '#f2fbfc',
      100: '#e0f5f8',
      200: '#b8e8ef',
      300: '#8adae5',
      400: '#4cc6d8',
      500: '#00aec7',
      600: '#008fa3',
      700: '#006f7f',
      800: '#004e5a',
      900: '#003138',
      950: '#001a1e',
    },
    danger: {
      50: '#fef2f2',
      100: '#fee2e2',
      200: '#fecaca',
      300: '#fca5a5',
      400: '#f87171',
      500: '#ef4444',
      600: '#dc2626',
      700: '#b91c1c',
      800: '#991b1b',
      900: '#7f1d1d',
      950: '#450a0a',
    },
    warning: {
      50: '#fffbeb',
      100: '#fef3c7',
      200: '#fde68a',
      300: '#fcd34d',
      400: '#fbbf24',
      500: '#f59e0b',
      600: '#d97706',
      700: '#b45309',
      800: '#92400e',
      900: '#78350f',
      950: '#451a03',
    },
    success: {
      50: '#f0fdf4',
      100: '#dcfce7',
      200: '#bbf7d0',
      300: '#86efac',
      400: '#4ade80',
      500: '#22c55e',
      600: '#16a34a',
      700: '#15803d',
      800: '#166534',
      900: '#14532d',
      950: '#052e16',
    },
  },

  fonts: {
    sans: ['Montserrat', 'system-ui', 'sans-serif'],
    mono: ['JetBrains Mono', 'Consolas', 'monospace'],
  },

  fontImports: [
    'https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800&display=swap',
    'https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400;500;600&display=swap',
  ],

  assets: {
    logo: 'brands/delta-dental/logo.svg',
    favicon: 'brands/delta-dental/favicon.png',
  },

  chartColors: [
    '#2db035', // Delta Dental Green (Primary)
    '#00aec7', // Cyan (Accent)
    '#0e5b6b', // Dark Teal
    '#dc582a', // Delta Dental Orange
    '#f59e0b', // Amber (Warning)
    '#ef4444', // Red (Danger)
    '#25902b', // Green Dark
    '#8adae5', // Cyan Light
    '#64748b', // Slate
    '#9edba2', // Green Light
  ],
};
